import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { createCokies, getOptionsForUser, getURLparam, hasURLparam } from "../../../Url";
import { Box } from "@mui/material";
import { getDocInfo, getIconsAsync, getSectionByID, isEmptyObject, openDocumentInModal } from "../../Tools/Tools";
import SectionSearch from "./SectionSearch";
import { renderMessageBox } from "../../../TokenProcessing/TokenProcessing";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import {
  animationsAtom,
  currentTheme,
  hasStartPageAtom,
  headFormAtom,
  sectionListAtom,
  selectedSectionAtom,
  setSelectedSectionAtom,
} from "../../../../atoms";
import { SectionListPageData, SectionsList } from "./SideBarInterface";
import ListItemSmeta from "./ListItemSmeta";
import { AxiosRequestConfig } from "axios";
import smetaAxios from "../../../SmetaAxios";
import { getHeadForm } from "../Header/Header";

interface SectionListInterface {
  $tag: number;
  HasStartPage?: "1" | "0";
  Head?: "1" | "0";
  NewsPageDate: string;
  PageID: string;
  Sections: SectionsList[];
  SupportService?: "1";
  theme: string;
}

export default function SideBar() {
  const setSelectedSection = useSetAtom(setSelectedSectionAtom);
  const setHeadForm = useSetAtom(headFormAtom);
  const [sectionList, setSectionList] = useAtom(sectionListAtom);
  const [collapseData, setCollapseData] = useState<{ id: boolean }>({});
  const theme = useAtomValue(currentTheme);
  const setHasStartPageAtom = useSetAtom(hasStartPageAtom);
  const animationsOn = useAtomValue(animationsAtom);
  const bgcolorthemeSelect = theme === "light" ? "#dcd8cc" : "#3d5b75";
  const bgcolortheme = theme === "light" ? "#faf9f5" : "#628cb6";
  const sideBarSelected = useAtomValue(selectedSectionAtom);

  useEffect(() => {
    getSectionList();
  }, []);

  async function parsedUrl(sideBarData: any) {
    if (hasURLparam("parsed") && sideBarData !== undefined) {
      const secid = getURLparam("secid");
      const jsondata = getSectionByID(secid);
      let dataAboutSelectedDoc = {
        Section: {
          CLSID: jsondata?.CLSID,
          ID: jsondata?.ID,
          Name: jsondata?.Name,
          Documents: jsondata?.Documents,
        },
      };
      if (hasURLparam("docid")) {
        const docId = getURLparam("docid");
        const docInfo = await getDocInfo(docId);
        if (!docInfo) return console.error("GetDocInfo: ошибка получения данных о документе");
        const docInfoSections = docInfo?.Sections?.split(",");
        const docCfgId = getURLparam("doccfgid");
        // const secId = getURLparam("secid");
        const card = hasURLparam("card");
        const modal = hasURLparam("modal");
        if (!dataAboutSelectedDoc.Section.ID && docInfoSections && docInfoSections.length > 0) {
          //находим и получаем данные из нашего списка секций
          for (const value of docInfoSections) {
            if (!dataAboutSelectedDoc.Section.ID) {
              const sectionInfo = getSectionByID(value);
              dataAboutSelectedDoc = { ...dataAboutSelectedDoc, Section: sectionInfo };
            }
          }
        }
        dataAboutSelectedDoc = {
          ...dataAboutSelectedDoc,
          docid: docId,
          DocCfgID: docCfgId || docInfo.DocCfgID,
          card,
          modal,
          Who: "Documents",
        };
        if (docInfo.Result === "1" && dataAboutSelectedDoc.DocCfgID) {
          window.history.replaceState(
            { additionalInformation: "Переход" },
            "UrlSearch",
            window.location.href.split("?")[0],
          );
          if (dataAboutSelectedDoc.Section.ID) {
            selectSection(dataAboutSelectedDoc.Section.ID, dataAboutSelectedDoc);
            return true;
          } else if (modal) {
            openDocumentInModal(dataAboutSelectedDoc.DocCfgID, docId);
          }
        } else {
          renderMessageBox({ dlgType: 1, buttons: 1, message: "Документ не найден" });
        }
        return false;
      }
      // props.setSelected(newValue);
    }
    return false;
  }

  const selectSection = (id: string, selectedDoc?: any) => {
    const infoAboutSection = getSectionByID(id);
    if (isEmptyObject(infoAboutSection)) return;
    setSelectedSection({ ...infoAboutSection, Selected: selectedDoc });
  };

  const getSectionList = async () => {
    const reqConfig: AxiosRequestConfig = {
      params: {
        simple: "0",
        full: "1",
        png: "1",
      },
    };

    const defaultSectionList: SectionListPageData = await smetaAxios.get("getSectionList", reqConfig);
    setSectionList(defaultSectionList.Sections);
    const { PageID: pageId, HasStartPage: hasStartPage, Head: head } = defaultSectionList;
    const sectionFromStorage = getOptionsForUser();
    const idToSelect = sectionFromStorage?.ID || pageId;
    if (head === "1") {
      const headFormData = getHeadForm("GetSectionHead");
      setHeadForm(headFormData);
    }
    const createCollapseObj = (list: SectionsList[]): { id: boolean } => {
      return list.reduce((acc, value) => {
        const { ID: id } = value;
        const selected = idToSelect === id;
        if (!value.Sections) return { ...acc, [selected ? idToSelect : id]: selected };
        const childData = createCollapseObj(value.Sections);
        return { ...acc, [id]: childData[idToSelect] || false, ...childData };
      }, {});
    };
    const collapseObj = createCollapseObj(defaultSectionList.Sections);
    setCollapseData(collapseObj);
    setHasStartPageAtom(hasStartPage === "1");

    await getIconsAsync(85);
    if (!defaultSectionList || isEmptyObject(defaultSectionList)) {
      createCokies("LicG", "");
      if (getOptionsForUser()?.from) window.location.href = getOptionsForUser()?.from.replaceAll("@", "/");
      return;
    }
    if (await parsedUrl(defaultSectionList["Sections"])) return;
    // const docState: any = localStorage.getItem("docState");
    // docState = JSON.parse(docState);
    const selectedDoc = sectionFromStorage?.Selected;
    selectSection(idToSelect, selectedDoc);
  };

  const renderSectionList = (listTest: SectionsList[]) => {
    if (!listTest || listTest === undefined || listTest.length === 0) return;
    return listTest.map((value, index) => {
      const { ID: id } = value;
      return (
        <div key={index + id}>
          <ListItemSmeta
            value={value}
            selected={sideBarSelected.ID === id}
            expandButton={Boolean(value.Sections)}
            collapse={collapseData[id]}
            onCollapse={(collapseId) => {
              const collapseBoolean = collapseData[collapseId];
              if (collapseBoolean === undefined) return;
              setCollapseData({ ...collapseData, [collapseId]: !collapseBoolean });
            }}
            onClick={(selectId) => {
              selectSection(selectId);
            }}
          />
          <Collapse in={collapseData[id]} timeout={animationsOn ? "auto" : 0} unmountOnExit>
            {renderSectionList(value.Sections || [])}
          </Collapse>
        </div>
      );
    });
  };

  window.onpopstate = (event) => {
    if (event && event.currentTarget && event.currentTarget === window) {
      window.location.reload();
      return;
    }
  };

  return (
    <Box style={{ scrollbarWidth: "none" }} sx={{ overflow: "auto" }}>
      <SectionSearch sectionArr={sectionList} />
      <List
        component="div"
        disablePadding
        sx={{
          "&& .Mui-selected, && .Mui-selected:hover": {
            backgroundColor: bgcolorthemeSelect,
          },
        }}
      >
        {renderSectionList(sectionList)}
      </List>
    </Box>
  );
}
